import axios from "axios";
import moment from "moment";
import { BASE_API_URL } from "../constants/allConstants";

const expiryTime = 1000 * 60 * 50;
// Delete url cache
const deleteCache = (url) => {
  localStorage.removeItem(url);
  return null;
};

// get saved url cache
const getCache = (url) => {
  try {
    const result = JSON.parse(localStorage.getItem(url));
    moment();
    if (result) {
      const response = result.response;
      const setDate = result.date;
      var start = moment(new Date());
      var end = moment(new Date(setDate));
      const difference = moment.duration(start.diff(end)).asMilliseconds();
      return difference > expiryTime ? deleteCache(url) : response;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};
// set url cache
const setCache = (url, response, date) => {
  localStorage.setItem(url, JSON.stringify({ response, date }));
};

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((request) => {
  const url = request.url;
  const method = request.method;
  const savedData = getCache(url);
  if (url.includes(BASE_API_URL) && method !== "get") {
    deleteCache(url);
  } else if (url.includes(BASE_API_URL) && savedData && method === "get") {
    request.adapter = () => {
      return Promise.resolve({
        data: savedData,
        status: 200,
        statusText: "FROM_CACHE",
        headers: request.headers,
        config: request,
        request: request,
      });
    };

    return request;
  }
  return request;
});
axiosInstance.interceptors.response.use((response) => {
  const url = response.config.url;
  const data = response.data;
  const method = response.config.method;
  if (
    url.includes(BASE_API_URL) &&
    response.status === 200 &&
    response.statusText !== "FROM_CACHE" &&
    method === "get"
  ) {
    setCache(url, data, new Date());
    console.log("FETCHED");
  } else {
    console.log("FROM_CACHE");
  }
  return response;
});

export default axiosInstance;
